export default "__VITE_ASSET__2VIkqF9s__"